export default {
  '测试结果详情':'Test Result Details',
  '测试结果列表':'Test Result List',
  '请输入学生姓名、学籍号':'Please enter student name or ID',
  '同步组织测试':'Sync Organization Test',
  '批量删除':'Batch Delete',
  '测评报告':'Assessment Report',
  '同步成功后，将覆盖展示最新的一次成绩':'After syncing, the latest score will overwrite existing data',
  
  '学年':'Academic Year',
  '年级':'Grade',
  '班级编号':'Class ID',
  '班级名称':'Class Name',

  'BMI':'BMI',
  '身高(cm)':'Height(cm)',
  '体重(KG)':'Weight(KG)',
  '肺活量(ml)':'Lung Capacity(ml)',
  '50米跑(秒)':'50m Sprint(seconds)',
  "800米跑(分秒)":"800m Run(min'sec)",
  "1000米跑(分秒)":"1000m Run(min'sec)",
  '坐位体前屈(cm)':'Sit-and-Reach(cm)',
  '一分钟跳绳(次)':'1-minute Rope Skipping(count)',
  '一分钟仰卧起坐(次)':'1-minute Sit-ups(count)',
  "50米X8往返跑(分秒)":"50m×8 Shuttle Run(min'sec)",
  '立定跳远(cm)':'Standing Long Jump(cm)',
  '引体向上(次)':'Pull-ups(count)',
  '免检原因':'Exemption Reason',

  '同步中':'Syncing',
  '请选择组织测试计划':'Select an organization test plan',
  '请选择记录':'Select a record',
  '是否确认删除勾选学生测试结果？':'Confirm to delete selected student test results?',
  '删除后不可恢复，确认删除吗？':'Deleted data cannot be recovered. Confirm deletion?',
  '删除成功！':'Deleted successfully!',
  '是否确认删除学生{name}测试结果？':'Confirm to delete test result of student {name}?',
  
  '新增计划':'Add Plan',
  '详情':'Details',
  '导入':'Import',
  '同步':'Sync',
  '新增体质健康监测':'Add Physical Health Monitoring',
  '选择学年':'Select Academic Year',
  '同步组织测试':'Sync Organization Test',
  '同步成功后，将覆盖展示最新的一次成绩':'After syncing, the latest score will overwrite existing data',
  
  '参测人数':'Participants',
  '平均分':'Average Score',
  '优秀':'Excellent',
  '良好':'Good',
  '及格':'Pass',
  '不及格':'Fail',
  '操作账号':'Operator Account',
  '导入中，不允许重复同步':'Importing, duplicate sync not allowed',
  '同步成功！':'Sync succeeded!',
  '同步中，不允许重复导入':'Syncing, duplicate import not allowed',
  '新建成功':'Created successfully',
  '导入中，请勿删除':'Importing, do not delete',
  '同步中，请勿删除':'Syncing, do not delete',
  '是否确认删除{acayearSemCodea}-{acayearSemCodeb} {acayearSemName}测试结果?':'Confirm to delete {acayearSemCodea}-{acayearSemCodeb} {acayearSemName} test results?',

  '学生体质健康测试报告单':'Student Physical Health Test Report',
  '姓名：':'Name:',
  '班级：':'Class:',
  '学籍号：':'Student ID:',
  '性别：':'Gender:',
  '学校：':'School:',
  '单项指标':'Individual Metrics',
  '年级平均':'Grade Average',
  '体重指数（BMI）':'Body Mass Index (BMI)',
  '（单位：千克/米²）':'(Unit: kg/m²)',
  '肺活量':'Lung Capacity',
  '（单位：毫升）':'(Unit: ml)',
  '50米跑':'50m Sprint',
  '（单位：秒）':'(Unit: seconds)',

  '坐位体前屈':'Sit-and-Reach',
  '（单位：厘米）':'(Unit: cm)',
  '一分钟跳绳':'1-minute Rope Skipping',
  '（单位：次）':'(Unit: times)',
  '一分钟仰卧起坐':'1-minute Sit-ups',
  '50米×8往返跑':'50m×8 Shuttle Run',
  '（单位：分’秒）':"(Unit: min'sec)",
  '立定跳远':'Standing Long Jump',
  '引体向上（男）':'Pull-ups (Male)',
  '1000米跑（男）':'1000m Run (Male)',
  '一分钟仰卧起坐（女）':'1-minute Sit-ups (Female)',
  '800米跑（女）':'800m Run (Female)',
  '标准分':'Standard Score',
  '加分指标':'Bonus Metrics',
  '1分钟跳绳':'1-minute Rope Skipping',

  '总分':'Total Score',
  '年级平均':'Grade Average',
  '等级':'Grade',
  '总评：':'Overall Evaluation:',
  '1、总分由标准分与附加分之和构成，满分为120分。标准分由各单项指标得分与权重乘积之和组成，满分为100分。附加分根据实测成绩确定，即对成绩超过100分的加分指标进行加分，满分为20分；小学的加分指标为1分钟跳绳，加分幅度为20分；初中、高中和大学的加分指标为男生引体向上和1000米跑，女生1分钟仰卧起坐和800米跑，各指标加分幅度均为10分。':'1. Total score consists of standard score (max 100) and bonus score (max 20), totaling 120. Bonus scores are awarded for exceeding 100 in specific metrics: 20 points for 1-minute rope skipping in primary school; 10 points each for male pull-ups/1000m run and female sit-ups/800m run in secondary and higher education.',
  '等级判定':'2. Grading: ≥90.0 (Excellent), 80.0-89.9 (Good), 60.0-79.9 (Pass), ≤59.9 (Fail).',

  '体质健康监测模板':'Physical Health Monitoring Template.xlsx',
  '测试成绩导出xlsx':'Test Scores Export.xlsx',

  '选择组织测试':'Select Organization Test',
  '请选择组织测试':'Please select organization test',
  '同步方式':'Sync Method',
  '覆盖原成绩':'Overwrite Existing Scores',
  '择优更新':'Update with Better Results',
  '本次同步的项目将覆盖原有成绩':'This sync will overwrite all existing scores',
  '本次同步的项目与原有成绩择优后展示':'This sync will compare and display the best results',
  '正在同步中，请勿关闭本页面':'Syncing in progress, please do not close this page',
  '同步完成':'Sync Completed',
  '同步完成但有异常数据':'Sync completed with some anomalies',
  '取消同步':'Cancel Sync',
  '确定要取消同步吗':'Are you sure you want to cancel the sync',
  '同步异常数据':'Synchronization Error Data',
  '取消同步成功':'Sync cancelled successfully',
  '免考学生暂无报告单':'Exempted students currently have no report cards',
}